import { Link } from "react-router-dom";
import { MessageCircle, Phone } from "lucide-react";
import { SITE, waLink, TRIAL_WA } from "@/config/site";

export default function FloatingCtas() {
  return (
    <>
      <a
        href={waLink(TRIAL_WA)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp"
        aria-label="Book a free trial class on WhatsApp"
        className="hidden sm:flex fixed bottom-6 right-6 z-[70] w-14 h-14 rounded-full bg-[#25D366] text-white items-center justify-center shadow-[0_10px_30px_-8px_rgba(37,211,102,0.6)] hover:scale-110 transition-transform duration-300"
      >
        <MessageCircle size={24} />
      </a>
      <div className="sm:hidden fixed bottom-0 inset-x-0 z-[70] bg-paper/95 backdrop-blur-xl border-t border-ink/10 p-3 flex gap-2" data-testid="sticky-mobile-bar">
        <Link
          to="/play-first-pay-later"
          data-testid="sticky-bar-book"
          className="flex-1 rounded-full bg-brand text-white text-center font-semibold text-sm py-3"
        >
          Book Your 2 Trial Sessions
        </Link>
        <a
          href={`tel:+91${SITE.whatsapp.slice(2)}`}
          data-testid="sticky-bar-call"
          aria-label="Call now"
          className="w-12 rounded-full bg-ink text-paper flex items-center justify-center"
        >
          <Phone size={18} />
        </a>
        <a
          href={waLink(TRIAL_WA)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-bar-whatsapp"
          aria-label="Book on WhatsApp"
          className="w-12 rounded-full bg-[#25D366] text-white flex items-center justify-center"
        >
          <MessageCircle size={19} />
        </a>
      </div>
    </>
  );
}
